const SUBTEST_DATA = [
    'gpuTemp',
    'memTemp',
    'gpuPower',
    'clocksClkM',
    'clocksClkGpc',
    'nvSwitchTemp',
    'tLimitTemp',

    'iNPUTTotalBoard',
    'oUTPUTTotalGpu',
    'iNPUTCem50',
    'clkGpcHwMeasured',
    'clkGpcSwTarget',
    'clkPexGenHwMeasured',
    'clkPexGenSwTarget',
    'clkMHwMeasured',
    'clkMSwTarget',
    'globalTLimit'
]

const TEMP_ERROR = [
    'avg',
    'max',
    'min',
    'gpuNum',
    'runNum',
    'testNum',
    'subTestType'
]

export {
    SUBTEST_DATA,
    TEMP_ERROR
}